module.exports = __webpack_public_path__ + "media/images/icons/flags/NO-de56cebf95a85e87ec5604333c1fa038.svg";